import axios from "axios";
import { ILocationQueryCoordinate, LocationQueryEnum, IResponse } from "redmond";
import { config } from "../../config";

const ACTIVITIES_LOCATION_AUTOCOMPLETE_PATH = "/api/v0/autocomplete/experiences";

export const fetchActivityLocationByCoordinates = async (
  lat: number,
  lon: number
): Promise<IResponse> => {
  const body: ILocationQueryCoordinate = {
    LocationQuery: LocationQueryEnum.Coordinate,
    lat,
    lon,
  };

  const res = await axios.post(
    ACTIVITIES_LOCATION_AUTOCOMPLETE_PATH,
    { query: body },
    { baseURL: config.baseURL }
  );

  if (res.status === 499) {
    throw new Error("Request failed");
  }

  return res.data;
};
